/** @jsx jsx */
import { Flex, Label } from '@bottlebooks/gatsby-design-system';
import { jsx } from 'theme-ui';

export default function Badge({ icon, children, direction, className }) {
  return (
    <Flex
      gap={[0, 2]}
      align="center"
      direction={direction}
      className={className}
    >
      {icon}
      <Label sx={{ display: ['none', 'block'] }}>{children}</Label>
    </Flex>
  );
}
